module.exports = __webpack_public_path__ + "img/icon-company.8aacfd81.svg";